const {
  // REACT_APP_API_DOMAIN = 'lk-api.ustory.life',
  // REACT_APP_API_DOMAIN = 'story-api.me-interactive.net',
  REACT_APP_API_DOMAIN = 'story-apidev.me-interactive.net',
  PHONE_MASK = '999 999 99 99',
} = process.env;

// REACT_APP_API_DOMAIN = 'story-apidev.me-interactive.net';
// REACT_APP_API_DOMAIN = 'lk-api.ustory.life';
// REACT_APP_API_DOMAIN = 'story-api.me-interactive.net',

const CHAT_DOMAIN = 'https://chat-dev9.me-interactive.net/api/v4';
const CHAT_SOCKET = 'wss://chat-dev9.me-interactive.net/api/v4/websocket';

// const CHAT_DOMAIN = 'https://chat.ustory.life/api/v4';
// const CHAT_SOCKET = 'wss://chat.ustory.life/api/v4/websocket';

const protocol = 'https:';
const API_DOMAIN = `${protocol}//${REACT_APP_API_DOMAIN}`;

export { API_DOMAIN, PHONE_MASK, CHAT_DOMAIN, CHAT_SOCKET };
export const GET_USERS_URL = '/api/users';
export const LOGIN_URL = 'api/user/login';
export const REGISTER_URL = 'api/_p/user/register';
export const ME_URL = 'api/me';
export const getRecoveryPasswordUrl = (email: string): string =>
  `/api/_p/reset_password/send_code?email=${email}`;
export const NEW_PASSWORD_URL = '/api/_p/change_password_from_link';

export const CREATE_USER_URL = '/api/user/create';
export const getUserUrl = (id: number): string => `/api/user/${id}`;
export const SEND_INVITE_URL = '/api/user_activate/send';
export const delUserUrl = (id: number): string => `/api/user/${id}`;

export const uploadPhotoUrl = (modificationId: number): string =>
  `/api/modification/${modificationId}/upload_photos`;
export const delPhotoUrl = (id: number): string => `/api/photo/${id}`;
export const setMainPhotoUrl = (id: number): string => `/api/photo/${id}/set_main`;

export const sendSmsUrl = (country_name: string = 'Russia', country_code: string = '7') =>
  `/api/users/code_register_sms?country_name=${country_name}&country_code=${country_code}`;
export const GET_COUNTRY_ID = '/api/phone_codes';

export const GET_PROMOCODES_URL = '/api/promo_codes';
export const GET_PROMOCODES_STAT_URL = 'api/promo_code_stat_all';
export const getPromocodeStatUrl = (id: number) => `api/promo_code_stat?id=${id}`;
export const CREATE_PROMOCODE_URL = '/api/promo_code/create';
export const editPromocodeUrl = (id: number): string => `/api/promo_code/${id}`;
export const getPromocodeUrl = (id: number): string => `/api/promo_code/${id}`;
export const activatePromocodeUrl = (code: string): string => `/api/code_activation/${code}`;

export const GET_TRANSACTIONS_URL = '/api/transactions';
